<template>
  <div class="main-content" v-cloak>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="heading mb-3">
            <h1>{{ project.name }}</h1>
            <p>{{ project.description }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="filter-bar filter-full">
            <div class="filter-tabs">
              <ul>
                <li class="pointer" :class="{ active: filterType === '' }">
                  <a @click="setFilterType('')"
                    ><span>All</span> {{ originalDocs.length }}</a
                  >
                </li>
                <li
                  v-for="(eachCount, $index) in documents_count"
                  :key="$index"
                  class="pointer"
                  :class="{
                    active: filterType === eachCount.entity_group,
                    'text-uppercase': eachCount.entity_group === 'Dax',
                  }"
                >
                  <a @click="setFilterType(eachCount.entity_group)">
                    <span v-if="eachCount.entity_group == 'Priorities Matrix'"
                      >Priorities</span
                    >
                    <span v-else>{{ eachCount.entity_group }}</span>
                    {{ eachCount.total }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <svg
          class="rotate-infinite mx-auto"
          v-if="loading"
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="45"
          viewBox="0 0 18 15"
        >
          <g>
            <g>
              <path
                fill="#8e8e93"
                d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"
              />
            </g>
          </g>
        </svg>

        <div
          class="col-12 col-sm-6 col-md-4"
          v-for="(doc, $index) in documents"
          :key="$index"
        >
          <div class="grid-card-box">
            <a
              href="#"
              @click.prevent="goToApp(doc)"
              v-if="documents && documents.length"
            >
              <div class="card-img">
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-if="doc.entity_name == 'Dax'"
                  style="background-image: url('/assets/img/dax_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'MCode'"
                  style="background-image: url('/assets/img/m_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'RAWCode'"
                  style="background-image: url('/assets/img/r_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'PythonCode'"
                  style="background-image: url('/assets/img/r_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'RCode'"
                  style="background-image: url('/assets/img/r_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Notepad'"
                  style="background-image: url('/assets/img/r_thumbnail.png')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Planner'"
                  style="
                    background-image: url('/assets/img/planner-thumbnail.png');
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Model Planner'"
                  style="
                    background-image: url('/assets/img/model_planner_thumbnail.png');
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Pipeline Planner'"
                  style="
                    background-image: url('/assets/img/pipeline_thumbnail.png');
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Playlist'"
                  style="background-image: url('/assets/img/playlist_play.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Priorities Matrix'"
                  style="
                    background-image: url('/assets/img/priority-thumbnail.png');
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Portfolio'"
                  :style="{
                    backgroundImage:
                      'url(' +
                      Object.values(doc.portfolio.pictures)[0].thumb +
                      ')',
                  }"
                ></a>
                <VerticalColourPalette
                  v-else-if="
                    doc &&
                    doc.colour_generator &&
                    doc.colour_generator.meta.colours
                  "
                  v-bind:count="doc.colour_generator.meta.coloursAmount"
                  v-bind:colours="doc.colour_generator.meta.colours"
                />
                <a
                  class="card-img-bg"
                  v-else
                  href="javascript:;"
                  style="background-image: url('/assets/img/colours-pic.jpg')"
                ></a>
                <div class="card-hover-box">
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-if="doc.entity_name == 'Dax'"
                    :to="{
                      name: doc.entity_name,
                      query: { id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'MCode'"
                    :to="{ name: 'M Code', query: { id: doc.document_id } }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'PythonCode'"
                    :to="{ name: 'PythonCode', query: { id: doc.document_id } }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'RAWCode'"
                    :to="{ name: 'RAW Code', query: { id: doc.document_id } }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Notepad'"
                    :to="{ name: 'Notepad', query: { id: doc.document_id } }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'ColourFan'"
                    :to="{
                      name: 'Colours Fan',
                      query: { id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'ColourImage'"
                    :to="{
                      name: 'Image to Colours',
                      query: { id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'ColourPalette'"
                    :to="{
                      name: 'Colours Palette',
                      query: { id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Planner'"
                    :to="{
                      name: 'Analytics Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Model Planner'"
                    :to="{
                      name: 'Data Model Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                    :to="{
                      name: 'Data Pipeline Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                    :to="{
                      name: 'Priorities Matrix',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Portfolio'"
                    :to="{
                      name: 'Project Share',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <router-link
                    class="btn btn-sm-alternative-primary"
                    v-else-if="doc.entity_name == 'Playlist'"
                    :to="{
                      name: 'Playlist',
                      params: { doc_id: doc.document_id },
                    }"
                    >Open Document</router-link
                  >
                  <div class="card-hover-btn" v-if="project.mine">
                    <div class="card-btn delete-btn">
                      <a
                        onclick="return false"
                        @click="
                          markClickedAction();
                          removeConfirm(doc);
                        "
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="18"
                          viewBox="0 0 15 18"
                        >
                          <g>
                            <g>
                              <path
                                d="M9.75 7.5v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0zM6 6.75a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 6 6.75zm6.662-2.25H2.338l1.259 11.332a.75.75 0 0 0 .745.668h6.316a.75.75 0 0 0 .745-.667zM14.25 3a.75.75 0 0 1 0 1.5h-.079l-1.278 11.498A2.249 2.249 0 0 1 10.657 18H4.344a2.25 2.25 0 0 1-2.237-2.002L.829 4.5H.75a.75.75 0 0 1 0-1.5H4.5v-.75A2.25 2.25 0 0 1 6.75 0h1.5a2.25 2.25 0 0 1 2.25 2.25V3zm-7.5-1.5a.75.75 0 0 0-.75.75V3h3v-.75a.75.75 0 0 0-.75-.75z"
                              />
                            </g>
                          </g></svg
                      ></a>
                      <span
                        onclick="return false"
                        @click="
                          markClickedAction();
                          removeConfirm(doc);
                        "
                        >Remove from Project</span
                      >
                    </div>
                  </div>
                </div>
                <div class="project-tag">
                  <p class="project-name">
                    {{ project.name.substring(0, 21)
                    }}<b v-if="project.name.length > 21">...</b>
                  </p>
                </div>
              </div>
            </a>
            <div class="card-info">
              <div class="card-title">
                <h3>
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-if="doc.entity_name == 'Dax'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'MCode'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'RAWCode'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Planner'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Model Planner'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Portfolio'"
                  />
                  <img
                    src="/assets/img/playlist_small_play.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Playlist'"
                  />
                  <img src="/assets/img/picture-icon.svg" alt="" v-else />
                  <router-link
                    v-if="doc.entity_name == 'Dax'"
                    :to="{
                      name: doc.entity_name,
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'MCode'"
                    :to="{ name: 'M Code', query: { id: doc.document_id } }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'RAWCode'"
                    :to="{ name: 'RAW Code', query: { id: doc.document_id } }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'PythonCode'"
                    :to="{ name: 'PythonCode', query: { id: doc.document_id } }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'RCode'"
                    :to="{ name: 'RCode', query: { id: doc.document_id } }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Notepad'"
                    :to="{ name: 'Notepad', query: { id: doc.document_id } }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourFan'"
                    :to="{
                      name: 'Colours Fan',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourImage'"
                    :to="{
                      name: 'Image to Colours',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourPalette'"
                    :to="{
                      name: 'Colours Palette',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Planner'"
                    :to="{
                      name: 'Analytics Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Model Planner'"
                    :to="{
                      name: 'Data Model Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                    :to="{
                      name: 'Data Pipeline Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                    :to="{
                      name: 'Priorities Matrix',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Portfolio'"
                    :to="{
                      name: 'Project Share',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Playlist'"
                    :to="{
                      name: 'Playlist',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                </h3>
                <span class="btn shared-btn" v-if="doc.team_shared"
                  >TEAM DOCUMENT</span
                >
                <span class="btn shared-btn" v-else-if="doc.shared"
                  >SHARED</span
                >
                <span class="btn private-btn" v-else>PRIVATE</span>
              </div>
              <div class="card-profile">
                <div class="profile-author">
                  {{ doc.created_at | moment("D MMMM YYYY") }}
                </div>
                <div class="social-stats">
                  <span
                    ><img
                      src="/assets/img/bubble-icon.svg"
                      alt=""
                      width="18"
                    />{{ doc.comments_count }}</span
                  >
                  <span
                    :id="'card-like-icon' + $index"
                    :class="{ active: doc.liked }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="-1 -2 20 19"
                      style="width: 18px"
                    >
                      <g>
                        <g>
                          <g>
                            <path
                              stroke="#000"
                              stroke-width="1.5"
                              fill="#fff"
                              d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span class="m-0" :id="'likesCount' + $index">{{
                      doc.likes_count
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section
          class="text-center vertical-center mx-auto"
          v-if="documents && documents.length == 0 && !loading"
        >
          <div class="save-document-form" v-if="project.mine">
            <h2>Add your first Document</h2>
            <p>
              Add existing Documents to this Project, or head to the Apps Center
              and<br />
              create a new one to start of with the right foot!
            </p>
          </div>
          <div class="save-document-form" v-else>
            <h2>No documents exists in this Project.</h2>
          </div>
        </section>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import ApiService from "../../api/api.service";
import VerticalColourPalette from "../../components/partials/VerticalColourPalette";
import vmodal from "vue-js-modal";

export default {
  name: "ProjectView",
  components: {
    VerticalColourPalette,
    vmodal,
  },
  data() {
    return {
      project: {
        name: "",
        description: "",
      },
      documents: null,
      documents_count: null,
      loading: true,
      filterType: "",
      originalDocs: [],
    };
  },

  watch: {
    $route(to, from) {
      if (
        to.name == "Project View" &&
        this.project.name &&
        to.params.id != from.params.id
      ) {
        this.documents = [];
        this.loading = true;

        this.getProjectData();
      }
    },
  },
  mounted() {
    this.getProjectData();
  },

  methods: {
    getProjectData() {
      ApiService.setHeader();
      ApiService.get("/api/projects/" + this.$route.params.id)
        .then(({ data }) => {
          this.project = data.project;
          this.documents = data.documents;
          this.originalDocs = JSON.parse(JSON.stringify(data.documents));

          this.documents_count = data.documents_count;
          this.loading = false;
        })
        .catch((response) => {
          this.loading = false;
          console.log(response);
        });
    },
    removeConfirm(doc) {
      this.$modal.show("dialog", {
        title: "&nbsp;",
        text: '<p class="text-center">Are you sure you want to remove?</p>',
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: '<span class="red-txt">Remove</span>',
            handler: () => {
              ApiService.setHeader();
              ApiService.post("/api/projects/remove-doc", {
                project_id: this.project.id,
                document_id: doc.id,
              })
                .then((response) => {
                  this.documents = this.documents.filter((item) => {
                    return item.id != doc.id;
                  });
                  this.getProjectData();
                  this.$modal.hide("dialog");
                })
                .catch();
            },
          },
        ],
      });
    },

    setFilterType(val) {
      this.filterType = val;
      if (this.filterType) {
        this.documents = this.originalDocs.filter((item) => {
          return item.entity_group == this.filterType;
        });
      } else {
        this.documents = this.originalDocs;
      }
    },

    goToApp(doc, hash) {
      if (!this.clickedApp) {
        let to = {};
        if (doc.entity_name == "Dax") {
          to = { name: "Dax", query: { id: doc.document_id } };
        } else if (doc.entity_name == "MCode") {
          to = { name: "M Code", query: { id: doc.document_id } };
        } else if (doc.entity_name == "RAWCode") {
          to = { name: "RAW Code", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourFan") {
          to = { name: "Colours Fan", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourImage") {
          to = { name: "Image to Colours", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourPalette") {
          to = { name: "Colours Palette", query: { id: doc.document_id } };
        } else if (doc.entity_name == "Planner") {
          to = {
            name: "Analytics Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Priorities Matrix") {
          to = {
            name: "Priorities Matrix",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Model Planner") {
          to = {
            name: "Data Model Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Pipeline Planner") {
          to = {
            name: "Data Pipeline Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Playlist") {
          to = { name: "Playlist", params: { doc_id: doc.document_id } };
        } else if (doc.entity_name == "Portfolio") {
          to = {
            name: "Document View",
            params: { document_id: doc.document_id },
          };
        } else if (doc.entity_name == "RCode") {
          to = { name: "RCode", params: { document_id: doc.document_id } };
        } else if (doc.entity_name == "Notepad") {
          to = { name: "Notepad", params: { document_id: doc.document_id } };
        } else if (doc.entity_name == "PythonCode") {
          to = { name: "PythonCode", params: { document_id: doc.document_id } };
        }
        if (hash) {
          to.hash = "#comments";
        }
        this.clickedApp = true;
        this.$router.push(to);
      }
    },

    markClickedAction() {
      this.clickedApp = true;
      // reverting back
      setTimeout(() => {
        this.clickedApp = false;
      }, 300);
    },
  },
};
</script>

<style scoped>
.save-document-form {
  margin: auto;
}
.filter-tabs {
  width: 100% !important;
}

.card-hover-btn .delete-btn {
  top: -70px;
}
.card-hover-btn .delete-btn span {
  width: 180px;
}

.project-tag {
  height: 0px;
}

.project-tag .project-name {
  background: #23a6cd;
  color: #ffffff;
  visibility: visible;
  opacity: 1;
  left: 0;
  position: relative;
  font-size: 18px;
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
  width: 70%;
  box-shadow: 0 5px 15px 0 rgb(0 0 0 / 50%);
  bottom: 50px;
  font-weight: 400;
  padding: 5px 15px;
}
</style>
